import React, { useEffect } from 'react';
import { PromptConfirmation, ValidationProps } from 'ui';
import { ExtraFooterButton } from 'ui/common/select/types';
import { STATE } from 'app/constants';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { useOptions } from 'app/components/options-handler/hooks';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { UserMembersTranslation } from '../constants';
import { usePromptOnChange } from 'app/area/subscriber-groups/user-members/hooks';

interface UserMembersDetailsPickerProps {
  componentId: string;
  subscriberGroupId?: number;
  urlParamId: number;
  endpoint: string;
  shouldPrompt: boolean;
  valueItem: ComplexValue<number>;
  loadOptionsParams?: LoadOptions;
  optionsParams?: any;
  optionsRequestPayload?: any;
  searchRequired?: boolean;
  translation: UserMembersTranslation;
  validation?: ValidationProps;
  onChange: (value: ComplexValue<number>) => void;
  extraFooterButton?: ExtraFooterButton;
}

export const UserMembersHeaderPicker: React.FC<UserMembersDetailsPickerProps> = ({
  componentId, subscriberGroupId, endpoint, shouldPrompt, valueItem, onChange,
  loadOptionsParams, optionsParams, optionsRequestPayload, urlParamId,
  searchRequired, extraFooterButton, translation, validation
}) => {

  const {
    options,
    fetching,
    loadOptions,
    onLoadOptions
  } = useOptions(STATE.subscriberGroups, componentId, endpoint, subscriberGroupId, {
    loadOptionsParams, optionsParams, optionsRequestPayload
  });

  useEffect(() => {
    onChange({ value: undefined });

    if (!fetching && !!urlParamId) {
      onLoadOptions({});
      if (!fetching && !!options) {
        onChange({ value: urlParamId });
      }
    }
  }, []);

  const optionValue = options.find(option => option.value === urlParamId);

  const { displayPrompt, onPromptedChange, onContinue, onHide } = usePromptOnChange(shouldPrompt, onChange);

  return <>
    {shouldPrompt && displayPrompt
      && <PromptConfirmation
        title={translation.cancel_changes}
        description={translation.are_you_sure}
        continueText={translation.undo_all}
        cancelText={translation.go_back}
        onContinue={onContinue}
        onCancel={onHide} />}
    <div className="col-lg-6 col-sm-12">
      <SelectSingleHierarchy
        componentId={componentId}
        className={undefined}
        label={{ text: translation.subscriber_group_title }}
        valueItem={valueItem?.value === optionValue?.value ? { ...valueItem, description: optionValue?.description } : valueItem}
        descriptionAllLevels={true}
        onChange={onPromptedChange}
        searchRequired={searchRequired}
        extraFooterButton={extraFooterButton}
        options={options}
        fetching={fetching}
        loadOptions={loadOptions}
        onLoadOptions={onLoadOptions}
        placeholder={translation.search}
        includeDisabledLabel={translation.include_disabled}
        validation={validation} />
    </div>
  </>;
};
